<template>

  <div class="_pagina_simulazioni">

    <v-row class="px-6">
      <v-col sm="12" md="6">

        <div class="_box">
          <div class="_box_title">Dati generali</div>
          <div class="_box_info _dati_generali align-center justify-space-between">
            <div style="padding-right:15px;">
              <div data-tour-step-simulazioni="1">Squadra di appartenenza:
                <span v-if="isLoadingInfo">
                  <v-progress-circular v-if="isLoadingInfo" class="ml-2" size="12" width="2" indeterminate :color="scdColor"></v-progress-circular>
                </span>
                <span v-else> {{ info.nomeSquadra }}</span>
							</div>
              <div data-tour-step-simulazioni="2">Coordinatore di riferimento:
                <span v-if="isLoadingInfo">
                  <v-progress-circular v-if="isLoadingInfo" class="ml-2" size="12" width="2" indeterminate :color="scdColor"></v-progress-circular>
                </span>
                <span v-else> {{ info.usernameCoordinatore }}</span>
							</div>
              <div v-if="bandoConSimulazioni" data-tour-step-simulazioni="3">
								Simulazioni totali:
                <span v-if="isLoadingInfo">
                  <v-progress-circular v-if="isLoadingInfo" class="ml-2" size="12" width="2" indeterminate :color="scdColor"></v-progress-circular>
                </span>
                <span v-else-if="bandoConSimulazioni"> {{ info.simulazioniTotali }}</span>
							</div>
            </div>
            <div v-if="bandoConSimulazioni" data-tour-step-simulazioni="4" class="_semi_bold" :style="`padding: 5px 0; border-bottom:2px solid ${scdColor}`">Tempo da battere:
              <span v-if="isLoadingInfo">
                <v-progress-circular v-if="isLoadingInfo" class="ml-2" size="12" width="2" indeterminate :color="scdColor"></v-progress-circular>
              </span>
              <span v-else>{{ info.tempoDaBattere }} s </span>
            </div>
          </div>
        </div>

        <div class="_box" data-tour-step-simulazioni="5">
          <div class="_box_title">Statistiche</div>
          <div class="_box_info flex-column align-center">
						<template v-if="bandoConSimulazioni">
							<div class="_semi_bold mb-4">ULTIME {{ info.minimo_simulazioni_selezione }} SIMULAZIONI</div>
							<div class="_statistics_wrapper" >
								<div data-tour-step-simulazioni="6">
									<div>Simulazioni vincenti</div>
									<!--<div v-if="gamingAbilitato" class="_text_orange" style="font-size:11px">GAME SCORE</div>-->
									<div v-if="isLoadingInfo" class="justify-center">
										<v-progress-circular v-if="isLoadingInfo" class="mt-2" size="14" width="2" indeterminate :color="scdOrange"></v-progress-circular>
									</div>
									<div v-else class="_text_orange">{{ info.vincentiUltimeX }}</div>
								</div>
								<div data-tour-step-simulazioni="7">
									<div>Simulazioni Perdenti</div>
									<div v-if="isLoadingInfo" class="justify-center">
										<v-progress-circular v-if="isLoadingInfo" class="mt-2" size="14" width="2" indeterminate :color="scdColor"></v-progress-circular>
									</div>
									<div v-else>{{ info.perdentiUltimeX }}</div>
								</div>
								<div data-tour-step-simulazioni="8">
									<div>Percentuale simulazioni abbandonate</div>
                  <div v-if="isLoadingInfo" class="justify-center">
										<v-progress-circular v-if="isLoadingInfo" class="mt-2" size="14" width="2" indeterminate :color="scdColor"></v-progress-circular>
									</div>
									<div v-else>
                    {{ info.abbandonatePercUltimeX }}% ({{info.abbandonateUltimeX}})
                    <v-tooltip v-if="computedClienteClickdayIt" bottom close-delay="1000">
                      <template v-slot:activator="{ on }">
                        <v-icon small v-on="on" color="#6D94CD">mdi-information</v-icon>
                      </template>
                      <span>
                        Scopri di più leggendo il consiglio "Simulazioni abbandonate"
                        <!-- I link non sembrano essere funzionanti nei tooltip -->
                        <!-- <a href="/home#/gaming-consigli" target="_blank" style="color: inherit; text-decoration: underline;">
                        </a> -->
                      </span>
                    </v-tooltip>
                  </div>
								</div>
								<div data-tour-step-simulazioni="9">
									<div>Tempo medio</div>
									<div v-if="isLoadingInfo" class="justify-center">
										<v-progress-circular v-if="isLoadingInfo" class="mt-2" size="14" width="2" indeterminate :color="scdOrange"></v-progress-circular>
									</div>
									<div v-else class="_text_orange">{{ info.tempoMedioUltimeX }} s</div>
								</div>
							</div>
						</template>
						<template v-else-if="!bandoConSimulazioni">
							<div class="font-weight-medium">Per questo bando non sono previste simulazioni</div>
						</template>
          </div>
        </div>

        <div class="_box" data-tour-step-simulazioni="10">
          <div class="_box_title">Performace ultime simulazioni<span :style="`color:${scdColor}`">{{amIProvaGratuita ? ' - Esempio' : ''}}</span></div>
					<div class="_box_info flex-column align-center" style="padding:0;">
						<template v-if="bandoConSimulazioni">
							<div v-if="isLoadingInfo" class="justify-center">
								<v-progress-circular class="mt-5" size="20" width="2" indeterminate :color="scdColor"></v-progress-circular>
							</div>
							<v-data-table
								style="width:100%"
								class="performance-ultime-simulazioni-data-table"
								v-else
								:headers="headersLastSimulazioni"
								:items="info.lastSimulazioni"
								hide-default-footer
								:no-data-text="isLoadingInfo ? 'In caricamento..' : 'Ancora nessuna simulazione eseguita'"
							>
								<template slot="item" slot-scope="props">
									<tr class="_table_row" v-if="props.item.tempo == null" >
										<td>{{ computedDateTime(props.item.data_ora) }}</td>
										<td colspan="3" style="text-align: center;">Abbandonata</td>
									</tr>
									<tr :class="`_table_row ${info != null && props.item.tempo <= info.tempoDaBattere ? ' bg_green' : ' bg_red'}`" v-else>
										<td class="white--text">{{ computedDateTime(props.item.data_ora) }}</td>
										<td :class="`white--text _semi_bold`">{{ props.item.tempo + " s" }}</td>
										<td class="white--text">{{ props.item.posClassifica + "° di " + props.item.partecipantiTot + " partecipanti" }}</td>
										<td class="white--text">{{ props.item.mediaPartecipanti + " s" }}</td>
									</tr>
								</template>
							</v-data-table>
						</template>
						<template v-else-if="!bandoConSimulazioni">
							<div class="mt-4 font-weight-medium">Per questo bando non sono previste simulazioni</div>
						</template>
					</div>
        </div>
      </v-col>
      
      <v-col sm="12" md="6">

        <!-- Popup con Dati Modificabili per i nosti clicatori-->
        <div class="_box mb-0">
          <div class="_box_title _bg_orange" :style="`color:${scdOrange};`">|</div>
          <div class="_box_info d-flex justify-space-around align-center" style="height:115px;">
            <v-btn
	            data-tour-step-simulazioni="11"
	            rounded
	            depressed
	            :color="scdOrange"
	            class="_semi_bold white--text px-12"
	            @click="computedClienteClickdayIt ? popUpDatiCliccatore() : showDatiCliccatore()"
	            style="text-transform:none; letter-spacing:0.5px; height:50px;"
            >
              Apri Finestra Dati Personali
            </v-btn>
          </div>
        </div>

        <!-- <v-navigation-drawer width="500" right temporary absolute v-model="sidebarDatiCliccatoreVisibile">
          <dati-cliccatore-component v-if="sidebarDatiCliccatoreVisibile" :IdUtenteProp="info.idUtente"></dati-cliccatore-component>
        </v-navigation-drawer> -->

        <v-dialog v-model="isDatiCliccatoreDialogOpen" width="920">
          <v-card min-width=900 max-width=900>
            <v-card-title class="headline">
              <!-- <span class="ml-4">DATI CLICCATORE</span> -->
              <v-spacer></v-spacer>
              <v-btn color="black--text" icon @click="isDatiCliccatoreDialogOpen = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <div :style="`margin:0 10px 20px; color:${scdOrange}; font-weight:500;`">
                ATTENZIONE:<br>Questa finestra contiene i dati personali che possono essere richiesti durante le simulazioni. Devi quindi copiarli e incollarli in un blocco note per averli a portata di mano durante gli allenamenti.
              </div>
              <dati-cliccatore-component v-if="isDatiCliccatoreDialogOpen" :IdUtenteProp="info.idUtente"/>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :color="scdColor" style="text-transform:none; padding:0 20px; color:white;" depressed rounded class="mr-4 mb-3" @click="isDatiCliccatoreDialogOpen = false">Chiudi</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <div class="_box" data-tour-step-simulazioni="12">
          <div class="_box_title _bg_orange" >Simulazioni in corso</div>
          <div v-if="isLoadingInfo" class="d-flex justify-center">
            <v-progress-circular class="my-4" size="20" width="2" indeterminate :color="scdOrange"></v-progress-circular>
          </div>
          <div v-if="!isLoadingInfo" class="_box_info flex-column align-center text-center">
            <template v-if="!isLoadingInfo && bandoConSimulazioni">
	            <template v-if="!computedClienteClickdayIt">
                <div v-if="Math.abs(serverClientTimeDifferences) <= 0.3">L'orario del tuo PC è sincronizzato con l'ora corretta italiana <span class="_semi_bold">({{ (serverClientTimeDifferences > 0 ? '+' : '') + serverClientTimeDifferences.toFixed(1) }} secondi) - OK</span> </div>
                <div v-else-if="Math.abs(serverClientTimeDifferences) <= 1">L'orario del tuo PC è quasi sincronizzato con l'ora corretta italiana <span class="_semi_bold">({{ (serverClientTimeDifferences > 0 ? '+' : '') + serverClientTimeDifferences.toFixed(1) }} secondi) - OK</span> </div>
                <div v-else class="text-center">
                  <div>L'orario del tuo PC è circa <span class="error--text"><span class="_semi_bold">{{ Math.abs(serverClientTimeDifferences).toFixed(1) }}</span> secondi {{serverClientTimeDifferences > 0 ? 'indietro' : 'avanti'}}</span> rispetto all'ora corretta italiana,</div>
                  <div class="error--text">per correggere la sincronizzazione, segui le istruzioni presenti in <a :style="`color:${scdColor}`" href="https://clickday.it/come-sincronizzare-lorario-del-tuo-computer-con-lorologio-nazionale/" target="_blank">questo articolo</a></div>
                </div>
	            </template>
	            
	           <div v-if="computedClienteClickdayIt">
		           Utilizza il sito <a href="https://time.is" target="_blank" :style="`color: ${scdOrange}; text-decoration: underline;`">TIME.IS</a> per conoscere l’orario esatto ed essere perfettamente sincronizzato.<br>
		           Per scoprire come ottimizzare l’uso di <a href="https://time.is" target="_blank" :style="`color: ${scdOrange}; text-decoration: underline;`">TIME.IS</a> leggi il <a href="https://app.simulatoreclickday.it/#/gaming-consigli" target="_blank" :style="`color: ${scdOrange}; text-decoration: underline;`">consiglio</a> "Sfrutta ogni millisecondo con <a href="https://time.is" target="_blank" :style="`color: ${scdOrange}; text-decoration: underline;`">TIME.IS</a>".<br>
		           Non basarti sull’orario del tuo PC anche nel caso dovesse mostrare i secondi.
	           </div>
	            
	            <div class="_text_orange mt-6">Clicca su uno dei pulsanti per <span class="_semi_bold">decidere l'orario di inizio simulazione</span></div>
	            <div class="_text_orange mt-2">Attenzione! Prima di iniziare la simulazione, <span class="_semi_bold">apri la finestra dei dati personali</span> per poterli utilizzare. </div>
            </template>
						<template v-else-if="!bandoConSimulazioni">
							<div class="font-weight-medium">Per questo bando non sono previste simulazioni</div>
						</template>
          </div>
	        <div v-if="computedAmIDeveloper">
		        
		        <p :style="`color: ${scdGreen}`">
			        Questo campo è visibile solo allo sviluppatore.<br>
			        Per avviare una simulazione inserisci l'ID e clicca su uno dei tempi in basso.
		        </p>
		        <v-text-field
			        v-model="idSimulazioneInseritoManualmente"
			        label="ID Simulazione"
			        outlined
			        dense
			        type="number"
			        min="1"
			        max="8640"
		        ></v-text-field>
		      <!--  :rules="[v => v >= 1 && v <= 8640 || 'Inserire un numero fra 1 e 8640']" -->
	        </div>
          <template v-if="!isLoadingInfo">
            <div data-tour-step-simulazioni="13" class="_sim_container">
              <!-- <div class="_sim" v-for="sim in simulazioni" :key="sim.id"
                  :style="(sim.hasOwnProperty('is_near_to_start') && sim.is_near_to_start == true ? 'background-color: #cdd6e3; ' : '') + (info != null && !isEnteringSimulazione ? 'cursor:pointer' : 'cursor:not-allowed')"
                  @click="goToSimulazione(sim.id, sim.data_ora)"
              >
                {{ computedTime(sim.data_ora) }}
              </div> -->
              <div
	              class="_sim"
	              v-for="sim in simulazioni"
	              :key="sim.id"
	              :style="(sim.hasOwnProperty('is_near_to_start') && sim.is_near_to_start == true ? 'background-color: #cdd6e3; ' : '') + (info != null && !isEnteringSimulazione ? 'cursor:pointer' : 'cursor:not-allowed')"
	              @click="gestisciAvvioSimulazione(sim)"
              >
                {{ computedTime(sim.data_ora) }}
              </div>
            </div>
          </template>
        </div>

      </v-col>
    </v-row>

    <v-dialog persistent v-model="isAvvisoNuoveRegoleOpen" max-width="700">
      <v-card>
        <v-card-title class="headline">
          <span :style="'color:' + scdColor" class="mr-2">ATTENZIONE!</span>
          <!-- <v-progress-circular v-if="isLoadingDatiProfilo" size="18" width="2" indeterminate :color="scdColor"></v-progress-circular> -->
          <!-- <v-spacer></v-spacer>
          <v-btn color="black--text" icon @click="isAvvisoNuoveRegoleOpen = false">
            <v-icon>close</v-icon>
          </v-btn> -->
        </v-card-title>
        <v-card-text>
          <p style="font-size: 16px;">
            L'INAIL ha rilasciato le nuove regole tecniche, diverse da tutti i Click Day degli anni passati.<br>
            Per questo motivo abbiamo aggiornato il tipo di simulazione nel software, rendendolo il più simile possibile alla ipotetica schermata che ti troverai davanti il vero giorno del Click Day.<br><br>
            Se non hai ancora visto le nuove regole tecniche, <a href="https://clickday.it/click-day-bando-agricoltura-le-nuove-regole-tecniche/" target="_blank" :style="'color:' + scdColor">clicca qui</a> per saperne di più.<br><br>
            Clicca su “HO CAPITO” e segui la guida.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark :color="scdColor" @click="isAvvisoNuoveRegoleOpen = false, modaleLetta()">Ho capito</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>   

    <v-snackbar v-model="showSnackbar" bottom :timeout="7000" v-if="alertType != null && message != null" :color="(alertType == 'warning' ? 'warning' : (alertType != 'error' ? scdColor : 'error'))">
      <div class="d-flex align-center">
        <div>
          <b>{{ message }}</b>
        </div>
        <v-btn rounded depressed small color="white" :style="`color:${scdOrange}; text-transform:none;`" @click="alertType = null">
          <b>Chiudi</b>
        </v-btn>
      </div>
    </v-snackbar>

    <v-dialog persistent v-model="manutenzioneDialog" max-width="550">
      <v-card>
        <v-card-title class="headline">
          <span :style="`color:${scdOrange}`" class="mr-2">AVVISO DI MANUTENZIONE</span>
        </v-card-title>
        <v-card-text>
          <p :style="`font-size: 18px; font-weight:500; color:${scdColor}`">
            Stiamo effettuando una manutenzione,<br>
            le simulazioni torneranno diponibili verso le {{ orarioFineManutenzione }}.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mb-1" dark rounded depressed :color="scdColor" @click="manutenzioneDialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
	  
	  <v-dialog
		  v-model="incompatibleBrowserDialog"
		  persistent
		  width="600"
	  >
		  <v-card>
			  <v-card-title class="font-weight-bold" :style="`color:${scdRed}`">
				  ATTENZIONE!<br>
				  Browser non compatibile!
			  </v-card-title>
			  <v-card-text class="font-weight-medium" style="font-size: 16px">
				  Non è possibile svolgere la simulazione perché il browser che stai utilizzando non rientra in quelli compatibili.
			  </v-card-text>
			  <v-card-actions>
				  <v-spacer></v-spacer>
				  <v-btn
					  rounded
					  depressed
					  style="text-transform:none; color:white;"
					  :color="scdOrange"
					  @click="incompatibleBrowserDialog = false"
					  class="px-4"
				  >
					  Ho capito
				  </v-btn>
			  </v-card-actions>
		  </v-card>
	  </v-dialog>
	  
	  <v-dialog
		  v-model="dialogAccettazioneRegole"
		  persistent
		  width="unset"
	  >
		  <accettazione-regole
		    :info-cliccatore="info"
		    @regole-accettate="dialogAccettazioneRegole = false"
		  ></accettazione-regole>
	  </v-dialog>

  </div>
</template>

<script>
import mixin from '../mixins';

export default {
  data() {
    return {
      alertType: null,
      message: null,
      showSnackbar: false,

      utentePuoFareLaSimulazione: null,
      
      isAvvisoNuoveRegoleOpen: false,
      // team: null,
      // teamleader: null,
      // simulazioniTotaliEseguite: null,
      idCliccatore: this.computedIdUtente,
      isLoadingInfo: false,
      // tipoSimulazione: null,
      // codiceAziendale: null,
      // simulazioniRimanenti: null,
      // tempoDaBattere: null,

      datiFintiCliccatore: [], // popolato nel created
      // datiFintiAzienda: [], // popolato nel created
      // datiFintiRandom: [],

      sequenza: '',
      tipoCaptcha: null,
      tipoSequenza: null,
      stringaIndiciRandom: '',

      tourSteps: [], // Inizializzato dinamicamente da un'apposita funzione   

      isEnteringSimulazione: false,

      headersSimulazioni: [
        // { text: "Prossime Simulazioni", value: "data_ora", sortable: false, align: 'center' },
      ],
      simulazioni: [],  

      checkSimulazioniRoutineRef: null,

      ruolo: window.__RUOLO__,

      // copyToClipboardTxt: "Clicca qui per copiare velocemente il codice",

      // tempoMedioCliccatore: null,
      // tempoMinimoCliccatore: null,

      // dataStatsCliccatore: null,
      // options: null,

      // hasLoadedStats: false,
      headersLastSimulazioni: [
        { text: "Data e Ora", value: "data_ora", sortable: false },
        { text: "Il tuo tempo", value: "tempo", sortable: false },
        { text: "Classifica", value: "posClassifica", sortable: false },
        { text: "Tempo medio partecipanti", value: "mediaPartecipanti", sortable: false },
      ],
			bandoConSimulazioni: false,
      info: {
        lastSimulazioni: [],
	      bando: {
					route: null
	      }
      },
      serverClientTimeDifferences: null, // in secondi

      // Dati cliccatore
      isDatiCliccatoreDialogOpen: false,
      idCliccatoreToShowDati: null,

      manutenzioneDialog: false,
      orarioFineManutenzione: '',
	    
	    incompatibleBrowserDialog: false,
	    
	    idSimulazioneInseritoManualmente: null, // disponibile solo per lo sviluppatore,
	    
	    dialogAccettazioneRegole: false
    };
  },
  mounted() {
    // this.handleSimulazioneParams();
  },
	
  async created() {
    await this.getInfo();
		this.gestisciDialogAccettazioneRegole();
  },
	
  beforeDestroy() {
    clearInterval(this.checkSimulazioniRoutineRef);
  },
	
  methods: {
    // ...mapActions([
    //     'handleSimulazioneParams'
    // ]),
    getInfo: function(){ // Restituisce le informazioni basilari del Cliccatore (Simulazioni Rimanenti, Tempo da battere, Squadra, ecc):
      this.isLoadingInfo = true;

      return axios.get("/cliccatore/info")
        .then(response => {
          if (response.data.hasError) {
            this.alertType = "error";
            this.message = response.data.message;
          } else {
            this.info = response.data;
            this.bandoConSimulazioni = this.info.bando_con_simulazioni;

						if (!this.bandoConSimulazioni) {
							this.isLoadingInfo = false;
							return;
						}
						// console.log(this.bandoConSimulazioni);

            // Calcolo le differenze di tempo tra l'ora del Server e del Client
            // NOTA IMPORTANTE: quando fai i test in locale questo valore non sarà corretto (time del server = time del pc)
            var client = new Date();
            var server = new Date(this.info.serverTime);

            // NOTA: per ora disattivata ogni correzione. Non è per nulla precisa e sfalsa il valore perché il tempo di andata è maggiore di quello di ritorno (con server a basso carico)
            // La correzione possiede tempo di andata e ritorno. Il tempo di ritorno in genere è maggiore di quello di andata.
            // Dato che mi interesserebbe solo il tempo di ritorno, invece di dividere per 2 considero 3/4 (0.75):
            // let correzione = (this.datetimeStartServerTimeRequest - (new Date()))*0.75;
            // console.log("correzione: " + correzione);

            // Applico la correzione (sottraendo dal tempo del Client)
            // client = client - correzione;

            // => Se il Client è avanti, il num sarà positivo. Se il Server è avanti, il num sarà negativo
            this.serverClientTimeDifferences = (server - client)/1000; // Calcolo in secondi

            // ======= Info contiene anche la prossima Simulazione (se presente): =====
            this.simulazioni = [];

            // Se non c'è alcuna prossima simulazione allora esci
            // if(this.info.nextSimulazione == null || this.info.nextSimulazione == undefined || this.info.nextSimulazione == "") return;

            this.addSimulazioni(8, this.info.nextSimulazione, false);

            // Avvio la routine (ogni secondo):
            this.checkSimulazioniRoutineRef = setInterval(this.checkSimulazioniRoutine, 1000);
          }
        })
        .catch(error => {
          this.alertType = "error";
          this.message = "Errore nel caricamento delle informazioni del cliccatore";
          this.showSnackbar = true;
        })
        .finally(() => {
          this.isLoadingInfo = false;
        });
    },
    addSimulazioni: function(numSimToAdd, startingSimulazioneObj, isStartingSimulazioneAlreadyIncluded){
      let dataOra = moment(startingSimulazioneObj.data_ora, "YYYY-MM-DD HH:mm:ss");
          
      let idSimulazione = startingSimulazioneObj.id;

      for(let i=0; i<numSimToAdd; i++){ // Inserisco le simulazioni:

        // Se la simulazione da cui partire è già presente, inserisco da quella successiva:
        if(isStartingSimulazioneAlreadyIncluded) dataOra = dataOra.add(10, 'seconds');

        this.simulazioni.push({
          id: idSimulazione + (isStartingSimulazioneAlreadyIncluded ? i+1 : i),
          data_ora: dataOra.format('YYYY-MM-DD HH:mm:ss')
        });

        // Se la simulazione da cui partire non è già presente, inserisco da questa:
        if(!isStartingSimulazioneAlreadyIncluded) dataOra = dataOra.add(10, 'seconds');
      }
    },
    checkSimulazioniRoutine: function(){ // Avviata solo quando la simulazione 0 è caricata:
      let datatimeSimulazione0 = moment(this.simulazioni[0].data_ora, "YYYY-MM-DD HH:mm:ss");

      // Le simulazioni ISMEA le faccio scomparire 1s in ritardo:
      if(this.isBandoISMEAComputed){
        datatimeSimulazione0 = datatimeSimulazione0.add(2, 'seconds');
      }

      // Elimino dal TOP le simulazioni iniziate (possono essere molteplici se ho cambiato TAB Chrome)
      while(datatimeSimulazione0.isBefore(moment())){

        // Elimino l'elemento dal TOP
        this.simulazioni.shift();        
        
        // Aggiungo un'altra simulazione:
        this.addSimulazioni(1, this.simulazioni[this.simulazioni.length - 1], true);

        // Considero la nuova simulazione0
        datatimeSimulazione0 = moment(this.simulazioni[0].data_ora, "YYYY-MM-DD HH:mm:ss");
      } 
      
      datatimeSimulazione0.subtract(5, 'seconds'); // Mancano 5 secondi all'avvio!
      if(datatimeSimulazione0.isBefore(moment())) { // La coloro di giallo se sta per iniziare
        this.simulazioni[0].is_near_to_start = true; 
        // Forzo aggiornamento UI:
        this.simulazioni = JSON.parse(JSON.stringify(this.simulazioni));
      }

    },
	  async gestisciAvvioSimulazione(simulazione) {

      // TODO: da completare
      // Se sono nel bando ISMEA, controllo che l'orario di inizio sia passato, altrimenti blocco
      if(this.isBandoISMEAComputed){
        if(!await this.controllaOrarioInizio(simulazione.data_ora)){
          this.alertType = "warning";
					this.message = "Puoi avviare la simulazione solo all'orario indicato";
					this.alertColor = 'red';
					this.showSnackbar = true;
          return;
        }
      }

		  await this.getMinimumBrowsersVersionsData(); // nel mixin
		  
		  if (
				!this.isTheBrowserCompatible()
		    && this.computedClienteClickdayIt
			  && this.minimumBrowsersVersionsData.browser_version_checking_enabled // nel mixin
		  ) {
			  this.incompatibleBrowserDialog = true;
		  }
			else if (this.info != null && !this.isEnteringSimulazione) {
			  const puoFareLaSimulazione = await this.getIfUtentePuoFareLaSimulazione();
			  
				if (puoFareLaSimulazione) {
          await this.goToSimulazione(simulazione.id, simulazione.data_ora);
			  }
			  
		  }
	  },

    async controllaOrarioInizio(dataOra){
      return axios.post('/controllo_orario_inizio', {data_ora: dataOra})
      .then(response => {
        return response.data; // Può essere true o false
      })
    },

    getIfUtentePuoFareLaSimulazione() {
      return axios.get('/utentePuoFareLaSimulazione')
      .then(response => {
        this.utentePuoFareLaSimulazione = response.data.utentePuoFareLaSimulazione;

        if (!this.utentePuoFareLaSimulazione) {
          this.alertType = "warning";
          this.message = response.data.message;
          this.alertColor = 'warning';
          this.showSnackbar = true;
					
					return false;
        }
				else return true;
      })
    },

    async goToSimulazione(idSimulazione, dataOraSimulazione) {
      if (this.isEnteringSimulazione) return;

      let response = await this.manutenzioneAttiva();
      let infoManutenzione = response.data;
      if (!!infoManutenzione.manutenzione_attiva) {
        this.manutenzioneDialog = true;
        this.orarioFineManutenzione = infoManutenzione.orario_fine_manutenzione;
        return;
      }

      this.isEnteringSimulazione = true;
			
			if (this.idSimulazioneInseritoManualmente) {
				idSimulazione = Number(this.idSimulazioneInseritoManualmente);
			}

      if(window.__IS_FIRST_ACCESS_SIMULAZIONE__ == '1'){
        axios.get("/cliccatore/accessedSimulazione") // Aggiorno valore nel DB: is_first_access_simulazione = false;
        .then(response => {
          axios.get(`/cliccatore/accediSimulazione/${idSimulazione}/${this.info.bandoId}/${dataOraSimulazione}?guidata=true`) // passo guidata=true in modo da non considerare la simulazione skippata
              // window.location.href = "simulazione/"+id+"?guida=true";
          .then(response => {
            window.__IS_FIRST_ACCESS_SIMULAZIONE__ = '0'
            this.salvaSimulazioneSulDB(idSimulazione, dataOraSimulazione, true); // passo guidata=true in modo da mostrare la guida
          })  
        })
        .catch(()=>{
          // Non rimettere la variabile a false se c'è un errore, tanto cambierà pagina
          this.isEnteringSimulazione = false;
        });
      } else {
        // Controllo se ho skippato simulazioni:
        axios
        .get(`/cliccatore/accediSimulazione/${idSimulazione}/${this.info.bandoId}/${dataOraSimulazione}`)
        .then(response => {
          this.salvaSimulazioneSulDB(idSimulazione, dataOraSimulazione, false);
        })
        .catch(()=>{
          // Non rimettere la variabile a false se c'è un errore, tanto cambierà pagina
          this.isEnteringSimulazione = false;
        });
      }     
    },

    // Questa funzione inizializza la Simulazione e porta alla pagina in cui è possibile eseguirla
    salvaSimulazioneSulDB(idSimulazione, dataOraSimulazione, simulazioneGuidata) {
      axios.post('/salvaSimulazione', {
        id: idSimulazione,
        dataOra: dataOraSimulazione,
        simulazioneGuidata: simulazioneGuidata
      })
				.then(response => {
					if (response.data.hasError) {
						this.alertType = "error";
						this.message = response.data.message;
						this.alertColor = 'red';
						this.showSnackbar = true;

					} else {
						this.$router.push({ name: this.info.bando.route });
						// this.$router.push({ name: 'simulazione-isi-inail-route' });
					}
				})
				.catch(error => {
					this.alertType = "error";
					this.message = "Errore, impossibile avviare la simulazione";
					this.alertColor = 'red';
					this.showSnackbar = true;
				});
    },
    showDatiCliccatore(idCliccatore) {
      this.idCliccatoreToShowDati = idCliccatore;
      this.isDatiCliccatoreDialogOpen = true;
    },
	  gestisciDialogAccettazioneRegole() {
			if (
				(this.computedClienteClickdayIt || this.computedAmIDeveloper)
				&& (
					this.info.conferma_lettura_regole === false
					|| (
						this.info.conferma_lettura_regole_dopo_superamento_selezione === false
						&& this.info.selezione_superata === true
					)
				)
			) {
				this.dialogAccettazioneRegole = true;
			}
	  }
  },
  computed: {
    isBandoISMEAComputed(){
      if(this.info.bando.id == 28)
        return true;

      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
 @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600&display=swap');

  ._pagina_simulazioni {
    font-family: 'Montserrat', sans-serif !important;
    font-size: 14px;
    color: #6D94CD;
    font-weight: 400;
    line-height:1.5;
    padding-top: 20px;
  }

  ._box {
    margin-bottom: 20px;
  }

  ._box_title {
    font-size: 16px;
    font-weight: 600;
    text-align:center;
    background-color: #6D94CD;
    padding: 5px;
    color:white
  }

  ._box_info {
    display: flex;
    padding: 16px;
  }

  ._dati_generali span {
    font-weight: 600;
  }

  ._semi_bold {
    font-weight: 600;
  }

  ._statistics_wrapper {
    width: 100%;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    & > div {
      font-weight: 600;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }

  // ._statistics_wrapper > div {
    
  // }

  ._statistics_wrapper > div > div:first-child {
    font-size: 10px;
  }

  ._sim_container {
    height: 240px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  ._sim {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    border-radius: 50px;
    // background-color: #eaecef;
    background-color: #e4e9ee;
    margin: 5px;
    font-weight: 600;
    &:hover {
      border: 1px solid #6D94CD;
      background-color: #cdd6e3;
    }
  }

  ._small-text {
    display: inline-block;
    font-size: 18px;
    color: rgba(0,0,0,.6);
  }

  ._bg_orange {
    background-color: #e6901c;
  }
  

  ._text_orange {
    color: #e6901c;
  }

  @media screen and (min-width: 1140px) and (max-width: 1280px) {
    ._small-text {
      font-size: 15px !important;
    }
  }

  @media screen and (min-width: 960px) and (max-width: 1140px) {
    ._small-text {
      font-size: 11px !important;
    }
  }

  ::v-deep {
    .v-expansion-panel-header {
      // margin-top: 5px;
      // border: 1px solid #6D94CD;
      font-weight: bold;
      background-color: #6D94CD;
      color: white;
      // border-radius: 5px;
    }
    .theme--light.v-expansion-panels .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon {
      color: white;
    }
  //   .v-expansion-panel-header--active {
  //     min-height: 0px;
  //     border-top: 1px solid #6D94CD;
  //     border-left: 1px solid #6D94CD;
  //     border-right: 1px solid #6D94CD;
  //   }
  }

  ::v-deep .performance-ultime-simulazioni-data-table {
    background-color:#eeeeee;
    color: #6d94cd !important;
    & .v-data-table-header tr th {
      border-bottom: none !important;
      color: #6d94cd !important;
      // height: 18px;
      // font-size: 15px;     
      text-align: center !important;
      // &:not(:nth-child(2)) {
      //   color: #6d94cd;
      // }
      // &:nth-child(2) {
      //   color: #fff;
      //   background-color: #e6901c;
      // }
    }
    
  }

  ::v-deep .performance-ultime-simulazioni-data-table ._table_row {
    & td {
      border-bottom: 0 !important;
      font-size: 13px;
      text-align: center;
      height: 40px;
    }
    &.bg_green {
    background-color: #8bba40 !important;
  }
    &.bg_red {
      background-color: #bc2025 !important;
    }
  }

  // .performance-ultime-simulazioni-data-table ._il_tuo_tempo {
  //   background-color: #e6901c !important;
  // }
  
</style>